import { registerTenant, TenantId } from '~/tenants/common/registry';
import { MCM_CUSTOMER_JOB_METADATA } from '~/tenants/mcm/job-metadata';
import { TimeZone } from '~/lib/enum';
import { MCM_CUSTOMER_ORDER_METADATA, McmOrder, McmOrderSchema } from '~/tenants/mcm/model/McmOrder';
import McmProvider from '~/tenants/mcm/model/McmProvider';
import McmPhotoConfig from '~/tenants/mcm/performable/photo/McmPhotoConfig';
import McmPhotoJob from '~/tenants/mcm/performable/photo/McmPhotoJob';
import McmVirtualConfig from '~/tenants/mcm/performable/virtual/McmVirtualConfig';
import McmVirtualJob from '~/tenants/mcm/performable/virtual/McmVirtualJob';
import McmDroneConfig from '~/tenants/mcm/performable/drone/McmDroneConfig';
import McmDroneJob from '~/tenants/mcm/performable/drone/McmDroneJob';
import McmVideoConfig from '~/tenants/mcm/performable/video/McmVideoConfig';
import McmVideoJob from '~/tenants/mcm/performable/video/McmVideoJob';
import McmFloorplanConfig from '~/tenants/mcm/performable/floorplan/McmFloorplanConfig';
import McmFloorplanJob from '~/tenants/mcm/performable/floorplan/McmFloorplanJob';

import McmZillowConfig from '~/tenants/mcm/performable/zillow/McmZillowConfig';
import McmZillowJob from '~/tenants/mcm/performable/zillow/McmZillowJob';
import McmMatterportConfig from '~/tenants/mcm/performable/matterport/McmMatterportConfig';
import McmMatterportJob from '~/tenants/mcm/performable/matterport/McmMatterportJob';
import EmptyForm from '~/tenants/common/forms/EmptyForm';
import McmPhotoForm from '~/tenants/mcm/performable/photo/McmPhotoForm';
import McmVirtualForm from '~/tenants/mcm/performable/virtual/McmVirtualForm';
import McmDroneForm from '~/tenants/mcm/performable/drone/McmDroneForm';
import McmVideoForm from '~/tenants/mcm/performable/video/McmVideoForm';
import McmMatterportForm from '~/tenants/mcm/performable/matterport/McmMatterportForm';
import McmCustomer, { McmCustomerSchema } from '~/tenants/mcm/model/McmCustomer';
import { MCM_PROVIDER_DATA } from '~/tenants/mcm/data';
import McmSlideshowConfig from '~/tenants/mcm/performable/slideshow/McmSlideshowConfig';
import McmSlideshowJob from '~/tenants/mcm/performable/slideshow/McmSlideshowJob';
import McmSlideshowForm from '~/tenants/mcm/performable/slideshow/McmSlideshowForm';
import McmOrderForm from '~/tenants/mcm/form/McmOrderForm';
import McmPackageLuxury from '~/tenants/mcm/package/luxury/McmPackageLuxury';
import McmPackagePremium from '~/tenants/mcm/package/premium/McmPackagePremium';
import McmPackageCare from '~/tenants/mcm/package/care/McmPackageCare';
import McmPackageEssentialPlus from '~/tenants/mcm/package/essentialp/McmPackageEssentialPlus';
import McmPackageHighlight from '~/tenants/mcm/package/highlight/McmPackageHighlight';
import McmPackageEssential from '~/tenants/mcm/package/essential/McmPackageEssential';
import McmPackageLuxuryForm from '~/tenants/mcm/package/luxury/McmPackageLuxuryForm';
import McmPackagePremiumForm from '~/tenants/mcm/package/premium/McmPackagePremiumForm';
import McmPackageCareForm from '~/tenants/mcm/package/care/McmPackageCareForm';
import McmPackageHighlightForm from '~/tenants/mcm/package/highlight/McmPackageHighlightForm';
import McmPackageEssentialPlusForm from '~/tenants/mcm/package/essentialp/McmPackageEssentialPlusForm';
import McmPackageEssentialForm from '~/tenants/mcm/package/essential/McmPackageEssentialForm';
import McmCustomerForm from '~/tenants/mcm/form/McmCustomerForm';
import McmPackageCrossroadsBasic from '~/tenants/mcm/package/cr_basic/McmPackageCrossroadsBasic';
import McmPackageCrossroadsBasicForm from '~/tenants/mcm/package/cr_basic/McmPackageCrossroadsBasicForm';
import McmPackageCrossroadsBronze from '~/tenants/mcm/package/cr_bronze/McmPackageCrossroadsBronze';
import McmPackageCrossroadsBronzeForm from '~/tenants/mcm/package/cr_bronze/McmPackageCrossroadsBronzeForm';
import McmPackageCrossroadsSilver from '~/tenants/mcm/package/cr_silver/McmPackageCrossroadsSilver';
import McmPackageCrossroadsGold from '~/tenants/mcm/package/cr_gold/McmPackageCrossroadsGold';
import McmPackageCrossroadsSilverForm from '~/tenants/mcm/package/cr_silver/McmPackageCrossroadsSilverForm';
import McmPackageCrossroadsGoldForm from '~/tenants/mcm/package/cr_gold/McmPackageCrossroadsGoldForm';
import McmPackageCrossroadsPlatinum from '~/tenants/mcm/package/cr_platinum/McmPackageCrossroadsPlatinum';
import McmPackageCrossroadsPlatinumForm from '~/tenants/mcm/package/cr_platinum/McmPackageCrossroadsPlatinumForm';
import McmSoldConfig from '~/tenants/mcm/performable/sold/McmSoldConfig';
import McmCustomJob from '~/tenants/mcm/performable/custom/McmCustomJob';
import McmCustomConfig from '~/tenants/mcm/performable/custom/McmCustomConfig';
import McmSoldJob from '~/tenants/mcm/performable/sold/McmSoldJob';
import McmCustomForm from '~/tenants/mcm/performable/custom/McmCustomForm';
import McmStagingConfig from '~/tenants/mcm/performable/staging/McmStagingConfig';
import McmStagingForm from '~/tenants/mcm/performable/staging/McmStagingForm';
import McmStagingJob from '~/tenants/mcm/performable/staging/McmStagingJob';
import McmQuickConfig from '~/tenants/mcm/performable/quick/McmQuickConfig';
import McmQuickJob from '~/tenants/mcm/performable/quick/McmQuickJob';
import McmPaymentForm from '~/tenants/mcm/form/McmPaymentForm';
import McmEditingConfig from '~/tenants/mcm/performable/editing/McmEditingConfig';
import McmEditingJob from '~/tenants/mcm/performable/editing/McmEditingJob';
import TwtEditingForm from '~/tenants/twt/performable/editing/TwtEditingForm';
import TwtEditingAction from '~/tenants/twt/performable/editing/TwtEditingAction';
import { DeliverableType } from '~common/model/Deliverable';

export default function registerMcm() {
  registerTenant(TenantId.MOTION_CITY_MEDIA, McmOrderSchema, {
    name: 'Motion City Media',
    domain: 'studio.motioncitymedia.com',
    background: '#2b90f6',
    phone: '+17323009799',
    smsPrefix: 'Motion City Media, ',
    rainforestEnable: true,
    showCalculator: true,
    rainforestMerchantId: 'mid_2wpA05tzd3qHdDdZrkxKRS1xAmA',
    rainforestMerchantApplicationId: 'app_2wpA07S9sgUSiY56x3qKnlDQDRQ',
    logoRaster: 'https://media.photology.co/tenant/mcm/logo.png',
    logoVector: 'https://media.photology.co/tenant/mcm/logo.svg',
    legal: 'TBD',
    email: 'info@motioncitymedia.com',
    emailEnable: true,
    inboxEnabled: true,
    inboxConversation: true,
    invoiceSuperscript: true,
    invoiceDiscounted: true,
    inboxDaily: true,
    providers: MCM_PROVIDER_DATA,
    tax: '0.06625',
    // Buying the branded 9:16 needs a headshot here (registry.ts reelRequiresHeadshot).
    reelRequiresHeadshot: true,
    wizardPackage: true,
    providerClass: McmProvider,
    scheduleStartTime: '07:00',
    scheduleEndTime: '23:00',
    scheduleMinDaytime: '09:00',
    scheduleMaxDaytime: '15:30',
    scheduleNotifyChecked: true,
    locations: [
      {
        slug: 'ap',
        name: 'New Jersey',
        timezone: TimeZone.US_EASTERN,
        address: {
          line1: '658 Cookman Avenue',
          city: 'Asbury Park',
          state: 'NJ',
          zip: '07712',
          long: -74.01178829999999,
          lat: 40.2154613,
        },
      },
    ],
    orderClass: McmOrder,
    customerClass: McmCustomer,
    userback: true,
    customerOrderMetadata: MCM_CUSTOMER_ORDER_METADATA,
    customerSchema: McmCustomerSchema,
    customerJobMetadata: MCM_CUSTOMER_JOB_METADATA,
    forms: {
      orderConfigure: McmOrderForm,
      customer: McmCustomerForm,
      provider: EmptyForm,
      payment: McmPaymentForm
    },
    performables: {
      [McmPhotoConfig.id]: {
        config: McmPhotoConfig,
        form: McmPhotoForm,
        job: McmPhotoJob,
      },
      [McmVirtualConfig.id]: {
        config: McmVirtualConfig,
        form: McmVirtualForm,
        job: McmVirtualJob,
      },
      [McmDroneConfig.id]: {
        config: McmDroneConfig,
        form: McmDroneForm,
        job: McmDroneJob,
      },
      [McmVideoConfig.id]: {
        config: McmVideoConfig,
        form: McmVideoForm,
        job: McmVideoJob,
      },
      [McmFloorplanConfig.id]: {
        config: McmFloorplanConfig,
        form: EmptyForm,
        job: McmFloorplanJob,
      },

      [McmZillowConfig.id]: {
        config: McmZillowConfig,
        form: EmptyForm,
        job: McmZillowJob,
      },
      [McmMatterportConfig.id]: {
        config: McmMatterportConfig,
        form: McmMatterportForm,
        job: McmMatterportJob,
      },
      [McmSlideshowConfig.id]: {
        config: McmSlideshowConfig,
        form: McmSlideshowForm,
        job: McmSlideshowJob,
      },
      [McmEditingConfig.id]: {
        config: McmEditingConfig,
        form: TwtEditingForm,
        job: McmEditingJob,
      },
      [McmSoldConfig.id]: {
        config: McmSoldConfig,
        form: EmptyForm,
        job: McmSoldJob,
      },
      [McmCustomConfig.id]: {
        config: McmCustomConfig,
        form: McmCustomForm,
        job: McmCustomJob,
      },
      [McmStagingConfig.id]: {
        config: McmStagingConfig,
        form: McmStagingForm,
        job: McmStagingJob,
      },
      [McmQuickConfig.id]: {
        config: McmQuickConfig,
        form: EmptyForm,
        job: McmQuickJob,
      },
    },
    packages: [
      {
        config: McmPackageLuxury,
        form: McmPackageLuxuryForm,
      },
      {
        config: McmPackagePremium,
        form: McmPackagePremiumForm,
      },
      {
        config: McmPackageCare,
        form: McmPackageCareForm,
      },
      {
        config: McmPackageHighlight,
        form: McmPackageHighlightForm,
      },
      {
        config: McmPackageEssentialPlus,
        form: McmPackageEssentialPlusForm,
      },
      {
        config: McmPackageEssential,
        form: McmPackageEssentialForm,
      },
      {
        config: McmPackageCrossroadsPlatinum,
        form: McmPackageCrossroadsPlatinumForm,
      },
      {
        config: McmPackageCrossroadsGold,
        form: McmPackageCrossroadsGoldForm,
      },
      {
        config: McmPackageCrossroadsSilver,
        form: McmPackageCrossroadsSilverForm,
      },
      {
        config: McmPackageCrossroadsBronze,
        form: McmPackageCrossroadsBronzeForm,
      },
      {
        config: McmPackageCrossroadsBasic,
        form: McmPackageCrossroadsBasicForm,
      },
    ],
    // The agent's "Request Edits" on a delivered order: Twist's edit menu and
    // form (MCM is the sales demo), see McmEditingConfig.
    actions: [
      {
        id: 'edit',
        name: 'Request Edits',
        deliverable: [DeliverableType.PHOTO, DeliverableType.AERIAL],
        job: McmEditingConfig,
        form: TwtEditingAction,
        customer: { fields: ['images'] },
      },
    ],
  });
}
